import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import loadable from '@loadable/component';

import { useRouter } from 'app/helpers/routing';

import ErrorPage from 'app/components/ErrorPage';
import { HTTP_STATUS_CODE } from 'app/constants/ErrorConstants';
import connectRoute from 'app/routes/connectRoute';
import EventsActions from 'app/actions/EventsActions';
import { trackEventSearch } from 'app/actions/AnalyticsGa4Actions';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import { selectCurrentUser } from 'app/selectors/AuthSelector';
import { selectActiveFilters, selectEventIds } from 'app/selectors/events/EventsSearchSelector';

const EventsSearchPageContainer = loadable(() =>
  import('app/components/events/EventsSearchPage/EventsSearchPageContainer')
);

export function EventsSearchPageRoute() {
  const { query } = useRouter();
  const dispatch = useDispatch();
  const currentLibrary = useSelector(selectCurrentLibrary);
  const currentUser = useSelector(selectCurrentUser);
  const eventIds = useSelector(selectEventIds);
  const searchQuery = query.q;

  useEffect(() => {
    if (searchQuery) {
      dispatch(trackEventSearch({ searchQuery }));
    }

    if (currentUser) {
      dispatch(EventsActions.getMyInterestedEvents({ eventIds: eventIds.join(',') }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery, currentUser]);

  if (!currentLibrary.getIn(['events', 'enabled'])) {
    return <ErrorPage httpStatusCode={HTTP_STATUS_CODE.FORBIDDEN} pageMessageKey="events" />;
  }

  return <EventsSearchPageContainer />;
}

function getRouteData({ dispatch, state, query }) {
  const activeFilters = selectActiveFilters(state);
  const currentLibrary = selectCurrentLibrary(state);

  if (!currentLibrary.getIn(['events', 'enabled'])) return [];

  if (activeFilters.isEmpty() && Object.keys(query).length === 0) {
    return [dispatch(EventsActions.searchEvents()), dispatch(EventsActions.getCalloutFeaturedEvent())];
  }
  return [dispatch(EventsActions.searchEvents(query))];
}

export default connectRoute(EventsSearchPageRoute, {
  getRouteData,
  debounceOptions: {
    wait: 100 // milliseconds
  }
});
